import { createSlice } from "@reduxjs/toolkit";

export const initialState = 1;

export const tabSlice = createSlice({
  name: "activeTab",
  initialState,
  reducers: {
    setActiveTab: (_, action) => {
      return action.payload;
    },
  },
});

export const { setActiveTab } = tabSlice.actions;

export default tabSlice.reducer;
